import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const GeneralContractor = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my general contractor business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps general contractor businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for general contractor businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most general contractor businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my general contractor business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like general contractor. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for General Contractor - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "General Contractor CRM", url: "/industries/general-contractor" }
  ];

  const industryData = {
    name: 'General Contractor',
    title: 'Stop Losing Renovation Leads & Manage Projects Without the Chaos',
    subtitle: 'Capture project inquiries instantly, automate estimate follow-ups, and keep clients updated without constant calls',
    icon: '🔨',
    challenges: [
      'Leads go cold while preparing estimates',
      'Hard to follow up on all quote requests',
      'Clients constantly call for project updates',
      'Difficult to manage multiple projects',
      'Change orders create communication chaos'
    ],
    solutions: [
      'Instant inquiry capture and response',
      'Automated estimate follow-up sequences',
      'Project milestone update automation',
      'Centralized project management',
      'Change order tracking and approval'
    ],
    features: [
      'Lead CRM with project tracking',
      'Automated estimate follow-ups',
      'Project milestone notifications',
      'Photo documentation system',
      'Change order management',
      'Client portal for updates',
      'Subcontractor coordination',
      'Review automation'
    ],
    results: [
      '50% more estimates convert',
      '75% fewer status update calls',
      'Manage 3x more projects',
      '£12.5K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for General Contractor UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for general contractor businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for general contractor UK, general contractor business software, general contractor customer management, general contractor lead generation UK"
        url="/industries/general-contractor"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default GeneralContractor;